module.exports = __webpack_public_path__ + "img/fixImg-tu.07e8b083.svg";